import { Col, Flex, Form, message, Row } from 'antd';
import { CustomButton, CustomInput } from '../../../components';
import { sendContactSalesEmail } from '../../../apis/sendcontactemail';
import React from 'react';

interface ContactSalesTeamProps {
  closeModal: () => void;
}

interface FormValues {
  name: string;
  email: string;
  company_name: string;
  message?: string;
}

/**
 * Contact sales team form component
 *
 * @param closeModal - Function to close the modal after successful submission
 */
const ContactSalesTeam: React.FC<ContactSalesTeamProps> = ({ closeModal }) => {
  const [form] = Form.useForm<FormValues>();

  const onFinish = async (values: FormValues) => {
    const { success, message: resultMessage } = await sendContactSalesEmail({
      recipient: values.email,
      name: values.name,
      company_name: values.company_name,
      message: values.message || 'No additional message provided.',
      is_early_signup: false,
    });

    if (success) {
      message.success(resultMessage);
      form.resetFields();
      closeModal();
    } else {
      message.error(resultMessage);
    }
  };

  const onFinishFailed = () => {
    message.error('Please fill out all required fields.');
  };

  return (
    <div>
      <Form
        form={form}
        name='contactSalesForm'
        layout='vertical'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        <Row gutter={[12, 24]} style={{ margin: '0px' }}>
          <Col xs={24} sm={24} lg={12}>
            <Form.Item
              className='custom-input'
              label='Your Name'
              name='name'
              rules={[
                {
                  required: true,
                  message: 'Please input your name',
                },
              ]}
            >
              <CustomInput
                placeholder='First and last'
                height='36px'
                border='0px'
                bgColor='var(--light-gray)'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='38px'
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} lg={12}>
            <Form.Item
              label='Your email'
              name='email'
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please input a valid email',
                },
              ]}
            >
              <CustomInput
                placeholder='name@example.com'
                height='36px'
                border='0px'
                bgColor='var(--light-gray)'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='38px'
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='Company name'
              name='company_name'
              rules={[
                {
                  required: true,
                  message: 'Please input your company name',
                },
              ]}
            >
              <CustomInput
                placeholder='Your company’s name'
                height='36px'
                border='0px'
                bgColor='var(--light-gray)'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='38px'
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='How are you looking to use Zoomlogi?'
              name='message'
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <CustomInput
                placeholder='Describe how you plan to use Zoomlogi'
                height='100px'
                border='0px'
                bgColor='var(--light-gray)'
                textColor='var(--text-secondary)'
                borderRadius='8px'
                placeholderColor='var(--text-secondary)'
                lineHeight='38px'
              />
            </Form.Item>
          </Col>
        </Row>
        <Flex justify='end'>
          <div style={{ marginTop: '10px', marginRight: '6px' }}>
            <CustomButton
              text={'Submit'}
              bgColor='black'
              color='white'
              height='48px'
              width='100px'
              fontSize='16px'
              fontWeight='500'
              boxShadow='none'
              borderRadius='8px'
              htmlType='submit'
              margin-top='16px'
            />
          </div>
        </Flex>
      </Form>
    </div>
  );
};

export default ContactSalesTeam;
